import React from "react";
import { Col, Row, Tooltip } from "react-bootstrap";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

const data = [
  {
    year: "01",
    "Sales Revenue": 7660800000,
  },
  {
    year: "02",
    "Sales Revenue": 42681600000,
  },
  {
    year: "03",
    "Sales Revenue": 99809280000,
  },
  {
    year: "04",
    "Sales Revenue": 162846720000,
  },
  {
    year: "05",
    "Sales Revenue": 231575040000,
  },
];

const domain = [0, 200000000];

const COLORS = ["#2F80F5"];

const SalesGrowthChart = () => {
  return (
    <>
      <div className="financial-chart">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart width={730} height={250} data={data}>
            <CartesianGrid opacity={0.5} vertical={false} strokeDasharray="2" />
            <XAxis dataKey="name" tick={false} />
            <YAxis
              width={130}
              domain={domain}
              tickFormatter={(number) => `$${number}`}
              tickCount={8}
            />
            <Bar dataKey="Sales Revenue" fill={COLORS[0]} barSize={100} />
          </BarChart>
        </ResponsiveContainer>
        {/* =================================CHART STATISTICS TABLE======================================= */}
        <div className="chart-stats pt-3">
        <Row >
            <Col className="text-center col col-md-2">
              <p className="legend-cell_1">Year</p>
            </Col>
            {data.map((item) => {
              return (
                <>
                  <Col className="col col-md-2">
                    <p className="legend-cell_1">{item["year"]}</p>
                  </Col>
                </>
              );
            })}
          </Row>
          <Row className="align-items-center pt-3 hide-on-responsive">
            <Col md={2}>
              <div className="sales-growth-chart-legend">
                <p className="text-center fw-semibold ls-0">SALES REVENUE</p>
              </div>
            </Col>
            {data.map((item) => {
              return (
                <>
                  <Col md={2}>
                    <p className="legend-cell">
                      ${item["Sales Revenue"].toLocaleString()}
                    </p>
                  </Col>
                </>
              );
            })}
          </Row>
        </div>
      </div>
    </>
  );
};

export default SalesGrowthChart;
